import type { SVGProps } from "react";
export interface FireIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FireIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FireIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M9.933 14.027a1.125 1.125 0 0 1 1.682.822c.161 1.192.818 2.29 1.733 3.196.917.909 2.024 1.557 2.934 1.864l-.36 1.065-.36 1.066c-1.242-.42-2.643-1.253-3.797-2.396a9 9 0 0 1-1.607-2.138 5.86 5.86 0 0 0-.214 3.143l.11.446.026.113a1.125 1.125 0 0 1-2.15.62l-.039-.109-.082-.308A8.1 8.1 0 0 1 7.9 17.17c.382-1.29 1.076-2.409 1.91-3.057l.123-.085Zm6.35 5.882a1.125 1.125 0 0 1-.72 2.131z"
      />
      <path
        fill={color}
        d="M10.788 1.018a1.6 1.6 0 0 1 1.51.097l.207.155.316.29c2.033 1.948 3.101 4.557 3.13 7.036.2-.352.373-.705.513-1.036l.068-.133a1.126 1.126 0 0 1 1.863-.108c1.511 1.983 2.706 4.315 2.73 6.67v.01l-.011.471A9.126 9.126 0 0 1 2.875 14c0-3.104 1.832-5.204 3.46-6.9.85-.885 1.622-1.636 2.263-2.45.626-.795 1.047-1.558 1.206-2.385l.054-.21a1.73 1.73 0 0 1 .93-1.037M5.125 14a6.875 6.875 0 0 0 13.75.012l-.013-.31c-.08-1.111-.527-2.307-1.242-3.518-.172.27-.358.541-.562.801-.657.834-1.536 1.642-2.66 2.067a1.125 1.125 0 0 1-1.376-1.608c1.186-2.082.854-5.353-1.285-7.768-.324.887-.82 1.665-1.37 2.365-.732.93-1.635 1.812-2.409 2.618-1.62 1.688-2.833 3.21-2.833 5.34Z"
      />
    </svg>
  );
}
